:host {
  display: block;
}

.vin-input-group {
  @apply flex;
  @apply gap-x-3;
  @apply gap-y-2;
}